// AUTO-GENERATED GraphQL Builder for RouteTransferResult
import * as Builders from '../';
export class RouteTransferResultBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  transferId(){ return this.add('transferId'); }
  transferRef(){ return this.add('transferRef'); }
  status(){ return this.add('status'); }
  settlementStatus(){ return this.add('settlementStatus'); }
  simulated(){ return this.add('simulated'); }
  amount(){ return this.add('amount'); }
  onHold(){ return this.add('onHold'); }
  onHoldUntil(){ return this.add('onHoldUntil'); }
  ledgerSettled(){ return this.add('ledgerSettled'); }
}
